import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/users/user6.jpg'
import _imports_1 from '@/assets/images/users/user7.jpg'
import _imports_2 from '@/assets/images/users/user8.jpg'
import _imports_3 from '@/assets/images/users/user9.jpg'
import _imports_4 from '@/assets/images/users/user10.jpg'
import _imports_5 from '@/assets/images/users/user11.jpg'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle" }
const _hoisted_4 = { class: "trezo-card-dropdown relative" }
const _hoisted_5 = { class: "trezo-card-content -mx-[20px] md:-mx-[25px]" }
const _hoisted_6 = { class: "table-responsive overflow-x-auto" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "text-black dark:text-white" }
const _hoisted_9 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_10 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_11 = { class: "flex items-center gap-[9px]" }
const _hoisted_12 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_13 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_14 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_15 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_16 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_17 = { class: "flex items-center gap-[9px]" }
const _hoisted_18 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_19 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_20 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_21 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_22 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_23 = { class: "flex items-center gap-[9px]" }
const _hoisted_24 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_25 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_26 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_27 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_28 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_29 = { class: "flex items-center gap-[9px]" }
const _hoisted_30 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_31 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_32 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_33 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_34 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_35 = { class: "flex items-center gap-[9px]" }
const _hoisted_36 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_37 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_38 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_39 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_40 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_41 = { class: "flex items-center gap-[9px]" }
const _hoisted_42 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_43 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_44 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Courses")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500': true,
              active: _ctx.isActive,
            }),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }, [
              _createTextVNode(" All Courses "),
              _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" })
            ], -1)
          ]), 2),
          _cache[2] || (_cache[2] = _createStaticVNode("<ul class=\"trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none\"><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Paid </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Free </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Top Rated </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> Best Seller </button></li></ul>", 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[70] || (_cache[70] = _createElementVNode("thead", { class: "text-black dark:text-white" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " ID "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Course Name "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Category "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Instructor "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Enrolled "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Start Date "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " End Date "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Price "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Action ")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_8, [
            _createElementVNode("tr", null, [
              _cache[8] || (_cache[8] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #854 ")
              ], -1)),
              _createElementVNode("td", _hoisted_9, [
                _createVNode(_component_RouterLink, {
                  to: "/lms/course-details",
                  class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Cybersecurity Awareness ")
                  ])),
                  _: 1
                })
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Technology ", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Oliver Khan ")
                  ])
                ])
              ], -1)),
              _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 180 ")
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 25 Mar 2024 ")
              ], -1)),
              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 25 Apr 2024 ")
              ], -1)),
              _cache[14] || (_cache[14] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $49.99 ")
              ], -1)),
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_12, _cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_13, _cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_14, _cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #853 ")
              ], -1)),
              _createElementVNode("td", _hoisted_15, [
                _createVNode(_component_RouterLink, {
                  to: "/lms/course-details",
                  class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode(" Python Programming ")
                  ])),
                  _: 1
                })
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Science ", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Ava Cooper ")
                  ])
                ])
              ], -1)),
              _cache[22] || (_cache[22] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 250 ")
              ], -1)),
              _cache[23] || (_cache[23] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 20 Mar 2024 ")
              ], -1)),
              _cache[24] || (_cache[24] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 20 Apr 2024 ")
              ], -1)),
              _cache[25] || (_cache[25] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $45.32 ")
              ], -1)),
              _createElementVNode("td", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_18, _cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_19, _cache[17] || (_cache[17] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_20, _cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[30] || (_cache[30] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #852 ")
              ], -1)),
              _createElementVNode("td", _hoisted_21, [
                _createVNode(_component_RouterLink, {
                  to: "/lms/course-details",
                  class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode(" Big Data Analytics ")
                  ])),
                  _: 1
                })
              ]),
              _cache[31] || (_cache[31] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Health & Wellness ", -1)),
              _cache[32] || (_cache[32] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Isabella Evans ")
                  ])
                ])
              ], -1)),
              _cache[33] || (_cache[33] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 320 ")
              ], -1)),
              _cache[34] || (_cache[34] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 15 Mar 2024 ")
              ], -1)),
              _cache[35] || (_cache[35] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 15 Apr 2024 ")
              ], -1)),
              _cache[36] || (_cache[36] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $99.00 ")
              ], -1)),
              _createElementVNode("td", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_24, _cache[27] || (_cache[27] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_25, _cache[28] || (_cache[28] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_26, _cache[29] || (_cache[29] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[41] || (_cache[41] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #851 ")
              ], -1)),
              _createElementVNode("td", _hoisted_27, [
                _createVNode(_component_RouterLink, {
                  to: "/lms/course-details",
                  class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[37] || (_cache[37] = [
                    _createTextVNode(" Introduction to Blockchain ")
                  ])),
                  _: 1
                })
              ]),
              _cache[42] || (_cache[42] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Education ", -1)),
              _cache[43] || (_cache[43] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Mia Hughes ")
                  ])
                ])
              ], -1)),
              _cache[44] || (_cache[44] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 135 ")
              ], -1)),
              _cache[45] || (_cache[45] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 10 Mar 2024 ")
              ], -1)),
              _cache[46] || (_cache[46] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 10 Apr 2024 ")
              ], -1)),
              _cache[47] || (_cache[47] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $29.75 ")
              ], -1)),
              _createElementVNode("td", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_30, _cache[38] || (_cache[38] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_31, _cache[39] || (_cache[39] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_32, _cache[40] || (_cache[40] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[52] || (_cache[52] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #850 ")
              ], -1)),
              _createElementVNode("td", _hoisted_33, [
                _createVNode(_component_RouterLink, {
                  to: "/lms/course-details",
                  class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[48] || (_cache[48] = [
                    _createTextVNode(" Network Administration ")
                  ])),
                  _: 1
                })
              ]),
              _cache[53] || (_cache[53] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Food & Cooking ", -1)),
              _cache[54] || (_cache[54] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Noah Mitchell ")
                  ])
                ])
              ], -1)),
              _cache[55] || (_cache[55] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 460 ")
              ], -1)),
              _cache[56] || (_cache[56] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 05 Mar 2024 ")
              ], -1)),
              _cache[57] || (_cache[57] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 05 Apr 2024 ")
              ], -1)),
              _cache[58] || (_cache[58] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $56.99 ")
              ], -1)),
              _createElementVNode("td", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_36, _cache[49] || (_cache[49] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_37, _cache[50] || (_cache[50] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_38, _cache[51] || (_cache[51] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[63] || (_cache[63] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #849 ")
              ], -1)),
              _createElementVNode("td", _hoisted_39, [
                _createVNode(_component_RouterLink, {
                  to: "/lms/course-details",
                  class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                }, {
                  default: _withCtx(() => _cache[59] || (_cache[59] = [
                    _createTextVNode(" Artificial Intelligence ")
                  ])),
                  _: 1
                })
              ]),
              _cache[64] || (_cache[64] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " Lifestyle & Fashion ", -1)),
              _cache[65] || (_cache[65] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Olivia Lucy ")
                  ])
                ])
              ], -1)),
              _cache[66] || (_cache[66] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 515 ")
              ], -1)),
              _cache[67] || (_cache[67] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 10 Feb 2024 ")
              ], -1)),
              _cache[68] || (_cache[68] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 10 Mar 2024 ")
              ], -1)),
              _cache[69] || (_cache[69] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $78.75 ")
              ], -1)),
              _createElementVNode("td", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_42, _cache[60] || (_cache[60] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_43, _cache[61] || (_cache[61] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_44, _cache[62] || (_cache[62] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Pagination, {
        items: "6",
        total: "30",
        class: "px-[20px] md:px-[25px]"
      })
    ])
  ]))
}